var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNote = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 8.5H4m4-2H4m1-2H4M7 1H3c-.27 0-.52.11-.71.29A.99.99 0 0 0 2 2v8c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29A.99.99 0 0 0 10 10V4L7 1Zm0 0v3h3"
})));
SvgNote.viewBox = '0 0 12 12';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNote);
export default ForwardRef;